var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalyGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 301,
    viewBox: "0 0 213 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300 300.439V315.439H315V300.439H300ZM5 15.4395H295V-14.5605H5V15.4395ZM285 5.43945V300.439H315V5.43945H285ZM300 285.439H5V315.439H300V285.439ZM15 295.439V5.43945H-15V295.439H15ZM5 285.439C10.5229 285.439 15 289.917 15 295.439H-15C-15 306.485 -6.04572 315.439 5 315.439V285.439ZM295 15.4395C289.477 15.4395 285 10.9623 285 5.43945H315C315 -5.60622 306.046 -14.5605 295 -14.5605V15.4395ZM5 -14.5605C-6.04567 -14.5605 -15 -5.60627 -15 5.43945H15C15 10.9623 10.5228 15.4395 5 15.4395V-14.5605Z",
    fill: "url(#paint0_linear_67_693)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_67_693",
    x1: 150,
    y1: 0.43945,
    x2: 233,
    y2: 240.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EF9C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EF9C3",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalyGreen);
export default __webpack_public_path__ + "static/media/saly_green.d417a1293c711c68e288784b533adbdb.svg";
export { ForwardRef as ReactComponent };